"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationContext = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
exports.NotificationContext = react_1.default.createContext({});
var ILSnackbarNotificationsProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState({
        position: {
            horizontal: 'right',
            vertical: 'top',
        },
    }), state = _b[0], setState = _b[1];
    var _c = react_1.default.useState(false), open = _c[0], setOpen = _c[1];
    var _d = state.position, position = _d === void 0 ? {
        horizontal: 'right',
        vertical: 'top',
    } : _d, _e = state.key, key = _e === void 0 ? 'none' : _e, _f = state.severity, severity = _f === void 0 ? 'error' : _f, _g = state.timeout, timeout = _g === void 0 ? 6000 : _g, message = state.message, action = state.action;
    function onClose() {
        setOpen(false);
    }
    react_1.default.useEffect(function () {
        var timer = setTimeout(function () {
            onClose();
        }, timeout);
        return function () {
            clearTimeout(timer);
        };
    }, [open, timeout]);
    return (react_1.default.createElement(exports.NotificationContext.Provider, { value: {
            showNotification: function (params) {
                onClose();
                setState(params);
                setOpen(true);
            },
        } },
        react_1.default.createElement(material_1.Snackbar, { anchorOrigin: position, open: open, autoHideDuration: timeout, key: key },
            react_1.default.createElement(material_1.Alert, { severity: severity, sx: {
                    width: '100%',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderStyle: 'solid',
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    '& .MuiAlert-message': {
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                    },
                } },
                react_1.default.createElement("span", null, message),
                action &&
                    react_1.default.cloneElement(action, {
                        onClose: onClose,
                    }))),
        children));
};
exports.default = ILSnackbarNotificationsProvider;
